document.addEventListener('DOMContentLoaded', () => {
  const closeButton = document.querySelector('.close-button-promo')
  const promotionalContent = document.querySelector('.promotional-content')

  closeButton.addEventListener('click', () => {
    document.querySelector('.promotional-box').remove()
  })
})
